import { FC } from 'react';
import { ToolbarProps } from 'react-big-calendar';

import { CalendarEvent } from 'types/interviewSlots';

import JobseekerTimezoneLabel from '../JobseekerTimezoneLabel/JobseekerTimezoneLabel';
import NavigationControls from '../NavigationControls/NavigationControls';
import ViewSwitcher from '../ViewSwitcher/ViewSwitcher';
import styles from './Toolbar.module.scss';

interface ToolbarComponentProps extends ToolbarProps<CalendarEvent, object> {
  isMobile: boolean;
}

const Toolbar: FC<ToolbarComponentProps> = ({
  onNavigate,
  onView,
  label,
  view,
  isMobile
}) => {
  return (
    <>
      <div className={styles.toolbarContainer}>
        <NavigationControls date={label} view={view} onNavigate={onNavigate} />
        <JobseekerTimezoneLabel className={styles.timezoneLabelPlacement} />
        {!isMobile && <ViewSwitcher view={view} onView={onView} />}
      </div>
    </>
  );
};

export default Toolbar;
